<script setup>
import { useAuthStore } from '@core/stores/AuthStore'

const i18n = useI18n()
const router = useRouter()
const authStore = useAuthStore()

definePage({
  meta: {
    layout: 'blank',
    authenticatedOnly: true,
  },
})

const errorMessage = ref('')
const requestCompleted = ref(false)
const code = router.currentRoute.value.query.code

onMounted(() => {
  if (code && code.length > 0) {
    authStore.confirmDeletion({ code }).catch(error => {
      if (error.response?.data?.error) {
        errorMessage.value = error.response.data.error.message
      } else {
        console.error(error)
        errorMessage.value = i18n.t('Something went wrong')
      }
    }).finally(() => {
      requestCompleted.value = true
    })
  } else {
    errorMessage.value = i18n.t('Invalid deletion confirmation code')
    requestCompleted.value = true
  }
})
</script>

<template>
  <VCol
    cols="6"
    class="d-flex justify-center align-center my-5"
  >
    <VRow>
      <p v-if="requestCompleted">
        <span v-if="errorMessage">{{ errorMessage }}</span>
        <span v-else>
          {{ $t('Your account has been deleted!') }}
          <RouterLink to="/">
            {{ $t('Back to home page') }}
          </RouterLink>
        </span>
      </p>
    </VRow>
  </VCol>
</template>
